
  import bottomFooter from "~/components/bottomFooter.vue"

  export default {
    components: {
      bottomFooter
    },
    data() {
      return {
        embed:false,
      }
    },
    created(){
      if (this.$route?.query?.embed){
        this.embed = true;
      }
    }
  }
